import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { StorageService, LocalStorageEnum } from 'src/app/shared/storage.service';

export interface GroupRestrictionDialogData {
  organizationName: string;
  email: boolean;
  ip: boolean;
}

@Component({
  selector: 'app-group-restriction-dialog',
  templateUrl: './group-restriction-dialog.component.html',
  styleUrls: ['./group-restriction-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupRestrictionDialogComponent implements OnInit {
  organizationName: string;
  email = false;
  ip = false;
  supportEmail = environment.supportEmail;

  constructor(
    private dialogRef: MatDialogRef<GroupRestrictionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: GroupRestrictionDialogData,
    private storageService: StorageService,
  ) {
    this.organizationName = data.organizationName;
    this.email = data.email;
    this.ip = data.ip;
  }

  ngOnInit() {}

  handleDontShowClick() {
    const groupAccess = this.storageService.getLocalJSON(LocalStorageEnum.GroupRestriction) || {};
    groupAccess.dontShowDialog = true;
    this.storageService.setLocalItem(LocalStorageEnum.GroupRestriction, groupAccess);
    this.dialogRef.close();
  }
}
